import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Belt-and-suspenders auth: when third-party cookies are blocked by the
// browser (Safari ITP, Chrome strict mode, cross-origin between youngblack.tv
// and the backend domain), we fall back to a Bearer token stored in
// localStorage. The backend already accepts Authorization: Bearer for both
// user (session_token) and admin (admin_session) auth.
api.interceptors.request.use((config) => {
  if (typeof window === "undefined" || !window.localStorage) return config;
  const url = config.url || "";
  const isAdmin = url.includes("/admin");
  const tokenKey = isAdmin ? "ybtv_admin_token" : "ybtv_user_token";
  const token = window.localStorage.getItem(tokenKey);
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
